import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Section} from 'components/UIKit';
import * as locales from './locales';

interface ShopEmptyProps {}

function ShopEmptyComponent({i18n}: ShopEmptyProps & WithI18nProps) {
  return (
    <Section
      heading={i18n.translate('empty.heading')}
      subhead={i18n.translate('empty.subhead', {
        link: <a href={i18n.translate('empty.url')}>{i18n.translate('empty.link')}</a>,
      })}
      fullWidth
    />
  );
}

export const ShopEmpty = withI18n({
  id: 'ShopEmpty',
  fallback: locales.en,
})(ShopEmptyComponent);
